import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const helpApi = createApi({
  reducerPath: 'helpApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getHelpItems: builder.query({
      query: () => ({
        url: urls.help,
        method: 'GET',
      }),
    }),
    getHelpItem: builder.query({
      query: (id) => ({
        url: urls.helpDetail(id),
        method: 'GET',
      }),
    }),

    saveHelp: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.helpDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.help,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),

    deleteHelp: builder.mutation({
      query(id) {
        return {
          url: urls.helpDetail(id),
          method: 'DELETE',
        };
      },
    }),

    getHelpByUrlAndSlug: builder.query({
      query: ({ url, slug }) => ({
        url: urls.helpByUrlAndSlug(url, slug),
        method: "GET",
      }),
    }),
  }),
});


export const {
  useGetHelpItemsQuery,
  useGetHelpItemQuery,
  useSaveHelpMutation,
  useDeleteHelpMutation,
  useGetHelpByUrlAndSlugQuery
} = helpApi;
